import React, {Component} from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {Carousel} from "react-responsive-carousel";
import {computeSliderArrows, computeSliderCount, computeTotalSlides} from "./utils";

class ServiceCarousel extends Component {
    render() {
        let listPresent = this.props.serviceList && this.props.serviceList.length > 0;
        if (listPresent) {
            return <ServiceList
                serviceList={this.props.serviceList}
                onClick={(i) => this.props.onClick(i)}
            />;
        } else {
            return <EmptyList/>;
        }
    }
}

class ServiceList extends Component {
    constructor(props) {
        super(props);
        this.handleWindowResize = this.handleWindowResize.bind(this);
        this.setTotalSlides = this.setTotalSlides.bind(this);
        this.setSliderCount = this.setSliderCount.bind(this);
        this.setShowArrows = this.setShowArrows.bind(this);
        this.state = {
            totalSlides: computeTotalSlides(this.props.serviceList.length, 3),
            sliderCount: computeSliderCount(3),
            showArrows: computeSliderArrows(this.props.serviceList.length, 3),
            selectedItem: 0
        };
    }

    componentWillUnmount() {
        window.clearTimeout(this.throttle);
        window.removeEventListener('resize', this.handleWindowResize, false);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            selectedItem: 0
        });
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize, false);
        this.setState({
            selectedItem: 0
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.handleWindowResize();
    }

    setTotalSlides() {
        const totalSlides = computeTotalSlides(this.props.serviceList.length, 3);
        if (this.state.totalSlides !== totalSlides) {
            this.setState({
                totalSlides: totalSlides
            });
        }
    }

    setSliderCount() {
        const sliderCount = computeSliderCount(3);
        if (this.state.sliderCount !== sliderCount) {
            this.setState({
                sliderCount: sliderCount
            });
        }
    }

    setShowArrows() {
        const showArrows = computeSliderArrows(this.props.serviceList.length, 3);
        this.setState({
            showArrows: showArrows
        });

    }

    handleWindowResize() {
        window.clearTimeout(this.throttle);
        this.throttle = window.setTimeout(this.setTotalSlides, 100);
        this.throttle = window.setTimeout(this.setSliderCount, 100);
        this.throttle = window.setTimeout(this.setShowArrows, 100);
    }

    handleClick = (event) => {
        let index = parseInt(event.target.parentElement.dataset.key)
        this.props.onClick(index)
    }

    handleSelectedItem = (e) => {
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if (width < 992) {
            this.setState({selectedItem: e});
        } else if (e + 2 >= this.props.serviceList.length) {
            this.setState({selectedItem: this.props.serviceList.length - 1});
        } else if (e > 2 && e < 6) {
            this.setState({selectedItem: e});
        } else if (e < 2) {
            this.setState({selectedItem: 0});
        } else {
            this.setState({selectedItem: e});
        }
    }

    slidesCount() {
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if (width < 992) {
            return 1;
        } else if (this.state.selectedItem === 0 || (this.state.selectedItem === this.props.serviceList.length - 1)) {
            return this.state.sliderCount + 1
        } else {
            return this.state.sliderCount;
        }
    }

    listItemClassName = (index) => {
        if (index === 0 || index === this.state.selectedItem - 2) {
            return (
                "services-list__item"
            )
        } else {
            return (
                "left-margin services-list__item "
            )
        }
    }

    showPrevArrow = (index) => {
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (width < 992) {
            return (
                this.state.selectedItem >= 1
            )
        } else {
            return (
                this.state.selectedItem >= 2
            )
        }
    }

    showNextArrow = (index) => {
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (width < 992) {
            return (
                this.props.serviceList.length > 1 && (this.state.selectedItem + 1 !== this.props.serviceList.length)
            )
        } else {
            return (
                this.props.serviceList.length > 3 && (this.state.selectedItem + 1 !== this.props.serviceList.length)
            )
        }
    }

    render() {
        return (
            <>
                <Carousel
                    showThumbs={false}
                    onSwipeEnd={false}
                    onSwipeStart={false}
                    onSwipeMove={false}
                    swipeable={false}
                    infiniteLoop={false}
                    centerMode={true}
                    selectedItem={this.state.selectedItem}
                    onChange={(e) => {
                        this.handleSelectedItem(e)
                    }}
                    slidesCount={this.slidesCount()}
                    centerSlidePercentage={100 / this.state.totalSlides}
                    showArrows={this.state.showArrows}
                    renderArrowPrev={(clickHandler, hasPrev, labelPrev) =>
                        this.showPrevArrow() && (
                            <button onClick={clickHandler} class="control-arrow control-prev"/>
                        )
                    }
                    renderArrowNext={(clickHandler, hasPrev, labelPrev) =>
                        this.showNextArrow() && (
                            <button onClick={clickHandler} class="control-arrow control-next"/>
                        )
                    }
                >
                    {this.props.serviceList.map((service, index) => (
                        <div className={this.listItemClassName(index)} key={service.id}>
                            <div>
                                <h3 className="services-list__item__title">{service.name}</h3>
                                <div className='services-list__item__info'>
                                    <p className="services-list__item__text">{service.description}</p>
                                    <span className="services-list__item__price">
                                        <span className="services-list__item__price--dollar"/>
                                        {service.price}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </Carousel>
            </>
        );
    }
}

function EmptyList(props) {
    return <h1> No Services </h1>;
}

export default ServiceCarousel;
